import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * VIN capture configuration.
 *
 * @remarks
 * System-managed object specifying VIN capture requirements for the move workflow.
 * Typically set alongside isGhost flag for ghost moves.
 */
export const schema = z
  .object({
    capture: z.enum(['full', 'partial', 'none']).describe('Required VIN capture level in driver workflow').optional(),
  })
  .strict()
  .optional();

export type Vin = z.infer<typeof schema>;

export const definition = define({
  key: 'vin',
  schema,
  label: 'VIN Capture',
  description: 'VIN capture requirements for driver workflow. Set by system for ghost moves, not user-configurable.',
  kind: DEFINITION_KINDS.OUTPUT,
  category: CATEGORIES.OPERATIONAL_STATE.key,
  writableAtLevels: [LEVELS.MOVE],
  readableByRoles: [ROLES.ADMIN],
});
